import React from "react";

const Ornament = () => (
  <div className="orn" aria-hidden="true">
    <span className="orn-line" />
    <span className="orn-glyph">✽</span>
    <span className="orn-line" />
  </div>
);

export default Ornament;
